import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.disable-select {
    user-select: none; /* supported by Chrome and Opera */
   -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
   -moz-user-select: none; /* Firefox */
   -ms-user-select: none; /* Internet Explorer/Edge */
}

/* .MuiTooltip-tooltip {
  font-size: 30px;
}
.MuiTooltip-popper{
  font-size: 30px; 
} */

`;
